import { render } from "./AsahiButton.vue?vue&type=template&id=239e6d58&scoped=true"
import script from "./AsahiButton.vue?vue&type=script&lang=js"
export * from "./AsahiButton.vue?vue&type=script&lang=js"

import "./AsahiButton.vue?vue&type=style&index=0&id=239e6d58&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-239e6d58"]])

export default __exports__